module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VGROULETTE-8d8413abcfaab6f06bf78d0b32f06e9d.png";